import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["link", "alt"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { pxToRem } from 'utils/ui/units';
import { isDark } from 'utils/ui/colors';
import { jsx as _jsx } from "react/jsx-runtime";
var Wrapper = styled.span.withConfig({
  displayName: "Logo__Wrapper",
  componentId: "sc-16umae1-0"
})(["display:inline-block;height:100%;"]);
var Image = styled.img.attrs(function (p) {
  return {
    src: isDark(p.theme.background) ? p.theme.globals.logo.invertedUrl : p.theme.globals.logo.url
  };
}).withConfig({
  displayName: "Logo__Image",
  componentId: "sc-16umae1-1"
})(["position:relative;left:", ";top:", ";display:inline-block;width:", ";max-width:100%;height:100%;object-fit:contain;"], function (p) {
  return pxToRem(p.theme.globals.logo.offsetX);
}, function (p) {
  return pxToRem(p.theme.globals.logo.offsetY);
}, function (p) {
  return pxToRem(p.theme.globals.logo.width);
});
var Logo = function Logo(_ref) {
  var link = _ref.link,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? '' : _ref$alt,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  if (link) {
    return /*#__PURE__*/_jsx(Wrapper, {
      as: Link,
      to: link || '/',
      children: /*#__PURE__*/_jsx(Image, _objectSpread({
        alt: alt
      }, otherProps))
    });
  }
  return /*#__PURE__*/_jsx(Wrapper, {
    children: /*#__PURE__*/_jsx(Image, _objectSpread({
      alt: alt
    }, otherProps))
  });
};
export default Logo;